var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 9.82812V7.66753C0.46875 7.08312 0.9425 6.60938 1.52691 6.60938H14.4731C15.0575 6.60938 15.5312 7.08312 15.5312 7.66753L15.5273 11.7031H0.46875V9.82812ZM0.46875 9.82812H15.5312M8.9375 4.01562H13.0625V6.60938H8.9375V4.01562ZM2.9375 4.01562H7.0625V6.60938H2.9375V4.01562Z",
    stroke: "#252525",
    strokeOpacity: 0.8,
    strokeWidth: 0.703125,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.3125 11.4844V13.2031M14.5 11.4844V13.2031M1.0625 1.26562H14.9375V6.60938H1.0625V1.26562Z",
    stroke: "#252525",
    strokeOpacity: 0.8,
    strokeWidth: 0.703125,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedrooms);
export default __webpack_public_path__ + "static/media/bedrooms.311063e7aa5f0c3e1ae24672b41cb401.svg";
export { ForwardRef as ReactComponent };